<template>
	<div class="page">
		<top-header></top-header> 
		<b-container fluid style="margin-top: 5%;">
			
		<b-row class="mt-3 mb-2">
          <b-col class="col-md-6 col-sm-6 col-xs-6">
            <h3 class="text-white">Led Reports <!-- <spna style="font-size: 15px;">{{timeData}}</spna> --></h3>
          </b-col>
          <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">            
          </b-col>
        </b-row>
		</b-container>
		<b-container fluid>
			<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
			
			

			<b-row class="mt-4 mb-2 px-4">
                <b-col>
                  <b-form inline>
                    <b-form-group>
                      <!-- <b-calendar v-model="datefrom" ></b-calendar> -->
                      <label for="inline-form-input-name" class="mr-sm-2 justify-left">From: </label>                  
                      <b-form-datepicker
                        v-model="datefrom"
                        class="mr-sm-2"
                        size="sm"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      ></b-form-datepicker>
                      
                    </b-form-group>
                    <b-form-group class="ml-3">
                      <label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
                      <b-form-datepicker
                        v-model="dateto"
                        class="mr-sm-2"
                        size="sm"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      ></b-form-datepicker>                    
                    </b-form-group>
                   
                    
                    
                   <b-form-group class="ml-3">
                      <label for="inline-form-input-name" class="mr-sm-2 justify-left">Led: </label>
                      <b-form-select
					   v-model="ledvalue"
                        size="sm"
                        required
                      >
                        <b-form-select-option value="0">--- ALL LED--</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in $root.wattslight" v-bind:key="index" :value="'w'+item">{{
                          'W'+item}}</b-form-select-option>
                      </b-form-select>
                    </b-form-group>					
					<b-button @click="fetchRecords()" size="sm" class="mt-4 ml-4">Show Report</b-button>
                  </b-form>
                </b-col>
				<b-col class="text-right">
					<!-- <b-button  variant="dark" pill size="sm" class="mr-2 mt-10"  @click="downloadPDF()">Download PDF</b-button> -->
					<b-button class="mt-10" variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button>
				</b-col>
            </b-row>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="6">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12">
									<!-- <b-table show-empty striped hover :fields="fields" :items="recordsTop" small :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"> -->
									<b-table
									show-empty
									sticky-header
									responsive
									outlined
									caption-top
									hover
									head-variant="dark"
									borderless="borderless"
									id="my-table-live"
									stacked="md"
									stickyColumn="scrolled"
							
									:items="recordsTop"                  
									:fields="fields"
									:current-page="currentPage"
									:per-page="perPage"
									:filter="filter"
									:filterIncludedFields="filterOn"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									:sort-direction="sortDirection"
									@filtered="onFiltered"
									class="scrollH d-flex" >

									<template v-slot:cell(location)="row">
										<span :id="'l-'+row.index" pill variant="success">{{row.value}}</span>
										<b-popover
											:target="`l-${row.index}`"
											title="Location"
											triggers="hover focus">
											{{row.item.location}}													
										</b-popover>
									</template>

									<template #cell(data)="row">
									<!-- {{ row.item.data}} -->
										<b-table :items="row.item.data" :fields="fields_data"></b-table> 
										
									</template> 
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{recordsTop.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					
				</b-col>
			</b-row>
		</div>
		</b-container>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";


export default {
	name: 'Devices Record',
	components: {
		"top-header": Header,		
	},
	beforeDestroy(){
		//console.log("CLEAR INTERVAL DASHBOARD");	
		window.removeEventListener("scroll", this.onScroll, true)
	},
	mounted(){
		//this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'inventoryapi/led-report1',
			urlRecord:self.$session.get('apiurl')+'inventoryapi/led-report', 
			//fp_no: self.$route.params.fp_no,
		
			records: [],
			device: {},
			firstRecord:[],
      		recordsTop: [],
      		fields: [
			  	{ key: 'fp_no', label: 'F.No.', sortable: true, stickyColumn: true,  class: 'text-center',thStyle:'min-width:85px;' },
				{ key: 'location', label: 'Location', thStyle:'min-width:140px;',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 15){
								return value.substring(0,15)+"...";
							}
							
						}
						return value;
					},
				},
				{	key: 'data', label: 'Data', text: 'Data1',  value: 'data'  },
				{ key: 'insert_time', label: 'Insert Time',thStyle:'min-width:130px;', 
					formatter: (value, key, item) => {
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				}

				
				
		
			],
			fields_data: [
			{ key: "device_id", label: "Device Id" }

			],

			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
      		fieldattributList:['Quentity','Warranty','Brand','Vendor','Electrician'],
			datefrom:'',
			dateto:'',
			ledvalue:0,

     
		};
	},
	methods: {
		initload(){

		},
		fetchRecords(){
			var self = this;
			self.axios.post(self.urlRecord, {
				accesskey: self.$session.get('access_key'),
				datefrom: self.datefrom,
				dateto:self.dateto,
				wart: self.wart,
				ledvalue:self.ledvalue,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					var recordsTopvar = response.data.result.records;
					var ledVendors  = response.data.result.led_vendors;
					var ledelectrician  = response.data.result.electrician;
					var ledBands  = response.data.result.led_brands;

					self.loading = false;
					self.totalRows = self.records.length;
					self.device = response.data.result.device;									
					self.firstRecord =self.records[0];
         // self.recordsTop = response.data.result.records;


         

         /* ======= Push Light Wart Header ======= */        
          self.$root.wattslight.forEach(function(date) {   
          self.fields_data.push({ key: 'w'+date, label: "W"+date, variant: "secondary", class: "text-center"});
          });

          			self.recordsTop=[];
					recordsTopvar.forEach(function(element){

						var fettingData  ={};
						var vanderData   ={};
						var warrantyData ={};
						var brandData    ={};   
						var electricianData={}; 
						if(element.led_fittings!=null && element.led_fittings!=''){
							fettingData  =JSON.parse(element.led_fittings);
						}
						if(element.led_vendor!=null && element.led_vendor!=''){
							vanderData   = JSON.parse(element.led_vendor);
						}
						if(element.led_warranty!=null && element.led_warranty!=''){
							warrantyData = JSON.parse(element.led_warranty);
						}
						if(element.led_brand!=null && element.led_brand!=''){
							brandData    =JSON.parse(element.led_brand);  
						}  
						if(element.led_electrician!=null && element.led_electrician!=''){
							electricianData =JSON.parse(element.led_electrician);  
						}            
							var dataInner =[];               
							self.fieldattributList.forEach(function(attr){
							var dataVal ={};
							dataVal['device_id']=attr;
							self.$root.wattslight.forEach(function(wno) {  
								var wt ='w'+wno; 
								var wval =''; 
								switch(attr) {
									case 'Quentity':
									
									wval = fettingData[wt]>0?fettingData[wt]:0;
									break;
									case 'Warranty':
									var warrt ='warranty'+wno;                           
									wval = warrantyData[warrt]!='' && warrantyData[warrt]!=undefined?warrantyData[warrt]:'---';  
									break;
									case 'Brand':
									var wbart ='brand'+wno; 
									
									var brandId = brandData[wbart]!=''?brandData[wbart]:0; 

									var wbranArr =  ledBands.filter(function (item) {
										return item.id == brandId
									});

									if(wbranArr.length>0){
										wbranArr = wbranArr[0].brand_name;
									}else{
										wbranArr ='---';
									}                          
									wval = wbranArr;  
									break;
									case 'Electrician':
									var welect ='electrician'+wno;  

									var electricianId = electricianData[welect]!=''?electricianData[welect]:0; 

									var wElectArr =  ledelectrician.filter(function (item) {
										//console.log("item item item:::",item);
										return item.ele_id == electricianId;
									});
									if(wElectArr.length>0){
										
										wElectArr = wElectArr[0].username;
									}else{
										wElectArr ='---';
									}                          
									wval = wElectArr;  
									break;
									case 'Vendor':
									var wvandt ='vendor'+wno;   

									var vanderId = vanderData[wvandt]!=''?vanderData[wvandt]:'0';                            
									var wvalArr =  ledVendors.filter(function (item) {
										return item.id == vanderId
									});
									if(wvalArr.length>0){
										wvalArr = wvalArr[0].vendor_name;
									}else{
										wvalArr ='---';
									}                          
									wval = wvalArr;       
									break;
									default:
									wval = '';
								}
								dataVal[wt]=wval;

							});                 
							dataInner.push(dataVal);
							//dataInner.push({ device_id: attr, w20: 40, w35: 'Dickerson', w45: 'Macdonald' });
							
							})
						var rectodTopIN ={fp_no:element.fp_no,location:element.location,data:dataInner,insert_date:element.update_time}
						self.recordsTop.push(rectodTopIN);
						
					});					
					
					/* setTimeout(self.initload, self.$root.reload_duration); */
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						var fieldData = row[field.key];
						//console.log('field.keyfield.key'+field.key);
						if(field.key =='light_data'){
							var value = row[field.key];
							var threadValue =0;
							if(value!=null && value!='null'){
								var lightData = JSON.parse(value);							
								threadValue =  lightData.thread; 
							}
							fieldData=threadValue;
						}

						if(field.key == 'output_status'){
						if(fieldData ==1){
							fieldData = "ON";
						}else{
							fieldData = "OFF";
						}
					}

					if(field.key == 'door_status'){
						if(fieldData ==1){
							fieldData = "OPEN";
						}else{
							fieldData = "CLOSED";
						}
					}



						dataarr.push(fieldData);
					}

					
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_data_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		downloadPDF(){
			var self = this;

			var pdfMake = require('pdfmake/build/pdfmake.js');
			var pdfFonts = require('pdfmake/build/vfs_fonts.js');
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			var pdfdata = new Array();
			var data = new Array();
			var headerlength = 0;
			self.fields.forEach(element => {
				data.push(element.label);
				headerlength++;
			});

			var count = headerlength;
			pdfdata.push(data); 
			for(var i=0; i<self.records.length; i++){
				data = new Array();

				/* var output_status = self.records[i]['output_status'];
				var amp_r = self.records[i]['amp_r'];
				var amp_y = self.records[i]['amp_y'];
				var amp_b = self.records[i]['amp_b'];
				var kw_r = self.records[i]['kw_r']; */
				self.fields.forEach(element => {
					var value = self.records[i][element.key];

					if(element.key == 'total_kw'){
							value = (value/1).toFixed(3);
						}
						

						if(element.key =='light_data'){
						
							var threadValue =0;
							if(value!=null && value!='null'){
								var lightData = JSON.parse(value);							
								threadValue =  lightData.thread; 
							}
							value=threadValue;
						}

					if(element.key == 'output_status'){
						if(value ==1){
							value = "ON";
						}else{
							value = "OFF";
						}
					}

					if(element.key == 'door_status'){
						if(value ==1){
							value = "OPEN";
						}else{
							value = "CLOSED";
						}
					}



					data.push(value);
				});
				pdfdata.push(data);
			}
			var deviceid = self.fp_no
			

			var d = new Date();
			var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();


			var fontsize = 14;
			var page = "landscape";
			var pagesize = "A4";
			if (count < 10) {
				fontsize = 14;
				 page = "portrait";
				pagesize = "A4";
			} else if (count < 15) {
				 fontsize = 10;
				page = "portrait";
				 pagesize = "A4";
			} else if (count > 15) {
				 fontsize = 14;
				page = "landscape";
				pagesize = "A3";
			}


			var docDefinition = {
				content: [
					{ text: 'Device Report : '+deviceid, style: 'heading' },
					{ text: ' ', style: 'heading' },
                   	{
						layout: 'lightHorizontalLines',
						table: {
							headerRows: 1,

							body: pdfdata
						}
					}
				],
				styles: {
					heading: {
						fontSize: 20,
						alignment: 'center',
						lineHeight: 1,
						bold: true
					},
                    subheading: {
                        fontSize: 14,
						alignment: 'center',
						lineHeight: 2,
						bold: false
                    }
				}, 
				defaultStyle: {
					fontSize: fontsize,
					bold: false
				},
				//pageOrientation: 'landscape',
				pageSize: pagesize,
       			pageOrientation: page
			};
			pdfMake.createPdf(docDefinition).download("REPORT_"+uniq+".pdf");
		},
		onChangeEventHandler(imei,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei = imei;
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));			
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
			this.initload();
		},
		onChangeEventPhaseHandler(imei,phase,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei 	= imei; 
			o.phase = phase; 
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));
			console.log('asdasd');
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser_phase', o);
			}
			this.initload();
		},
	}
}
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-image: url(../../assets/home-banner.png) !important;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-position: center center; */
  background-position: bottom;
}

.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
#my-table-live .thead-dark th {
  color: #fff;
  background-color: #ff9a37;
  border-color: #ff9a37;
}
#my-table-live .first-col {
  border-radius: 20px 0px 0px 0px;
  min-width: 130px;
}
#my-table-live .last-cal {
  border-radius: 0px 20px 0px 0px;
  min-width: 153px;
}
.borderRadius20 {
  border-radius: 20px;
}
.table-responsive {
  border-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
}
.customselectfilter button{
  height: 36px;
}

.tbl-header{
  background: #c6c6c6;
    padding: 6px;
    margin-bottom: 5px;
    text-align: center;
    font-weight: 700;
}
</style>